
<transition name="fade">
  <div
    :class="['modal-backdrop', 'backdrop', size]"
    v-show="open"
    @click.self="closeBackdrop"
  >
    <transition :name="size === 'side' ? 'slide-from-right' : 'fade'">
      <div
        class="modal"
        :class="[size]"
        role="dialog"
        v-show="open"
      >
        <div class="modal-content">
          <header v-if="!hideHeader" class="modal-header">
            <div class="container">
              <align justify="space-between">
                <h4 class="secondary-font">{{ title }}</h4>

                <icon-button
                  class="modal-close"
                  icon="close"
                  @click="close"
                />
              </align>
            </div>
          </header>

          <section class="modal-body">
            <div class="container">
              <slot />
            </div>
          </section>
        </div>

        <section v-if="$slots.footer" class="modal-footer">
          <div class="container">
            <slot name="footer" />
          </div>
        </section>
      </div>
    </transition>
  </div>
</transition>
